import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function SAMPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Materials and Methods</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <h5>6.1 Introduction and study area</h5>

            <p>
              Kolkata Metropolitan Area (KMA), also termed as Greater Kolkata,
              was chosen for the analysis as shown in{" "}
              <a href="#_bookmark9">Fig. 14.2</a>. A buffer of 10 km was also
              considered around the boundary to understand UHI&rsquo;s
              phenomenon over the metropolitan. The city of Kolkata holds a
              significant position in Indian history as it was the first capital
              of British India and is one of the oldest metropolitan cities in
              India. It serves as a capital city for the Indian state of West
              Bengal and is located on the bank of river Hooghly. The
              metropolitan shares its boundary with the Indian state of Assam
              and Sikkim, along with an international boundary with Bangladesh.
              The metropolitan serves as a domineering center for Indian art,
              literature and is home to several architecture heritages. Earlier
              most of the metropolitan region was a wetland but as a result of
              increased movement of people and rising urbanization, it was
              converted into urban settlements. Later in August 2002, the
              undeveloped and the remaining part of wetlands were designated as
              Ramsar site, thus providing it with an environmental value.
            </p>
            <p>
              The metropolitan is spread across an area of 1886.67 km
              <sup>2</sup> and has an elevation of 1.5e9 m above MSL (mean sea
              level). As per Ko&uml;ppen climate classification, it has a
              tropical wet and dry climate. The mean annual temperature and
              rainfall over the city estimate to 26.8<sup>◦</sup>C and 1850 mm,
              respectively.
            </p>

            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/vlh2.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              FIGURE 14.2 Study area depicting KMA and its location in India.
            </p>

            <p>
              The region experiences four seasonsdsummer (March to June),
              monsoon (June to September), post-monsoon autumn transition
              (September to November), and winter (December to February). The
            </p>
            <p>
              minimum winter temperatures range from 9 to 11<sup>◦</sup>C, while
              the maximum summer temperature often exceeds &gt;40<sup>◦</sup>C.
              The population curve of the metropolitan is as shown in{" "}
              <a href="#_bookmark10">Fig. 14.3</a>.
            </p>
            <p>
              The metropolitan is home for several esteemed historical,
              cultural, and academic institutions of
            </p>
            <p>
              great national importance. It has many public and private sector
              industrial units including steel, minerals, heavy engineering,
              mining, electronics, textile, tobacco, food processing, and jute.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/vlh3.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>
              FIGURE 14.3 Demographic information of Kolkata Metropolitan Area.
            </p>

            <p>
              The region also houses the headquarters of various companies such
              as ITC Limited, Coal India Limited, Exide Industries, Britannia,
              etc. The city is connected via a good transportation system (road,
              rail, and air) with other parts of India as well as
              internationally. All this has contributed to the large-scale
              migration that has led to the development of the city with
              enormous landscape changes. The infrastructure of the region is
              highly diverse where few parts of the city have congested growth,
              old architecture, overpopulated slums, heavily crowded markets
              places, ramshackle buildings and narrow alleyway. In contrast, the
              other has a completely planned architecture with ample open and
              vegetated space. As a result of enormous growth and changes in
              urban pattern and structure of the metropolitan, numerous problems
              are being faced by the residents including a rise in pollution
              levels, increased level of discomfort, heat stress, and rise in
              the level of RSPM (respirable suspended particulate matter) that
              has led to increased cases of people with pulmonary related
              diseases. The city is facing various environmental problems that
              have affected the microclimate of the region in terms of surface
              temperature that has further led to increased intensity and days
              of UHI.
              <br />
              <br />
            </p>
            <h5>
              {" "}
              <b> 6.1.1 Method used</b>
            </h5>
            <p>
              A five-step process as shown in{" "}
              <a href="#_bookmark12">Fig. 14.4</a> was involved in the research
              work to fulfill the main objective. It includes: (1) Data
              acquisition and preprocessing, (2) Land use analysis, (3)
              Quantification of emissivity and Land Surface Temperature, 4)
              Estimation of Normalized Urban Heat Island Index (NUHII), (5)
              Derivation of relationship between LU and LST
            </p>

            <p>
              <ul>
                <li>
                  Data acquisition and preprocessing: Primary and secondary data
                  used for the analysis include Landsat series (5 thematic
                  mapper and 8 operational land imager/thermal infrared), city
                  development plan, survey of India toposheets (1:50,000 scale),
                  ground truth/collected data, data obtained from Google Earth
                  pro and CDP was georegistered using GCPs (ground control
                  points) obtained from Google Earth and ground collected data.
                  Toposheets, CDP, and maps from Bhuvan were used to delineate
                  the boundary of Kolkata Metropolitan Area (KMA). All the
                  remote sensing data were then corrected for any geometric
                  errors and was resampled with the help of ancillary data. All
                  the required bands were then cropped pertaining to the study
                  area.
                </li>
                <li>
                  Land use analysis: Land use analysis was performed using a
                  supervised classification technique and was estimated using
                  four At first, False Color Composite (FCC) was generated,
                  which involves assigning blue color to green band, green color
                  to red band, and red color to near-infrared (NIR) band. FCC is
                  useful as it can help in easy identification of certain
                  features due to the presence of heterogeneity among various
                  classes in urban areas. In the second step, representative
                  training polygons for each class were digitized taking into
                  account the heterogeneity and interclass variations using FCC.
                  These polygons were then converted into signature by using
                  mean and covariance matrix (obtained from overlapping polygons
                  and FCC). In the third step, classification was performed
                  using Gaussian maximum likelihood classifier that takes into
                  account the probability density function for assigning the
                  class to each pixel. Four classes, namely, urban, vegetation,
                  water, and others, were considered for this analysis.
                  Mathematically the algorithm can be defined as shown in{" "}
                  <a href="#_bookmark11">Eq. (14.5)</a>.
                </li>
              </ul>
            </p>
            <p style={{ textAlign: "center" }}>
              X &epsilon; Cj, if p(Cj / X)= max[p(C1 / X), p(C2 / X), ., p(Cm /
              X)].........(14.5)
            </p>

            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/vlh4.png" alt="" />{" "}
            </p>

            <p style={{ textAlign: "center" }}>FIGURE 14.4 Method.</p>

            <p>
              Here, p(Cj/X) denotes the conditional probability of pixel X being
              a member of the class; max [p(C1/X), p(C2/X), ., p(Cm/X)] is a
              function that returns the largest probability among four
              categories.
            </p>
            <p>
              The last step of land use analysis was accuracy assessment which
              was performed by comparing the classified map obtained from GMLC
              algorithm and validation map obtained from Google Earth and ground
              truth data for 2019. For historical years, the classified map was
              created using 70% of the signatures and validation map was created
              from the remaining ones. These maps, when compared to each other,
              generated a confusion matrix that was further used to estimate
              overall accuracy and kappa coefficient (measures of accuracy).
            </p>

            <p>
              <ul>
                <li>
                  Quantification of emissivity and LST: Emissivity was estimated
                  using NDVI threshold method. This method considers mixed
                  pixels of soil and vegetation and assigns values to them based
                  on the proportion of vegetation. A thorough literature review
                  was conducted to obtain the emissivity values of pure water,
                  soil, and vegetation class (&epsilon;<sub>water</sub> 9910,
                  &epsilon;
                  <sub>S</sub> 0.9668, &epsilon;<sub>V</sub>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 0.9863). The formulas used for
                  estimation of emissivity are as shown in{" "}
                  <a href="#_bookmark13">Eqs. (14.6)-(14.8</a>).
                </li>
              </ul>
            </p>
            <p style={{ textAlign: "center" }}>
              &epsilon;<sub>SV</sub> = &epsilon;<sub>V</sub>P<sub>V</sub> +
              &epsilon;<sub>S</sub>(1 &mdash; P<sub>V</sub>)+ C.........(14.6)
            </p>

            <p>Here,</p>
            <p>
              &epsilon;<sub>SV</sub> / emissivity of
              soil&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; vegetation
            </p>
            <p>
              &epsilon;<sub>V</sub> / emissivity of vegetation
            </p>
            <p>
              &epsilon;<sub>S</sub> / emissivity of soil
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/vlh147.png" alt="" /> ......(14.7)
            </p>

            <p>Here,</p>
            <p>
              P<sub>V</sub> / proportion of vegetation
            </p>
            <p>
              NDVI<sub>i</sub> / Normalized Difference Vegetation Index of the
              pixel under consideration
            </p>
            <p>
              NDVI<sub>S</sub> / NDVI of pure soil
            </p>
            <p>
              NDVI<sub>V</sub> / NDVI of pure vegetation
            </p>
            <p style={{ textAlign: "center" }}>
              C = (1 &mdash; &epsilon;<sub>S</sub>)&epsilon;<sub>V</sub>F(1
              &mdash; P<sub>V</sub>
              )........(14.8)
            </p>
            <p>Here,</p>
            <p>C / constant defining surface characteristics</p>
            <p>
              F / geometrical factor (depends on surface geometry, usually
              considered 0.55)
            </p>
            <p>
              Postestimation of emissivity, LST was quantified using Radiative
              Transfer Equation (RTE) that takes surface (emissivity) and
              atmospheric parameters (atmospheric transmittance, upwelling
              radiance, and downwelling radiance) into account. A simplified RTE
              can be expressed as shown in <a href="#_bookmark14">Eq. (14.9)</a>
              .
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/vlh149.png" alt="" /> ......(14.9)
            </p>
            <p>Here,</p>
            <p>
              B<sub>i</sub>(T<sub>i</sub>) / top-of-atmosphere radiance received
              at the sensor for channel i having T<sub>i</sub> at-satellite
              brightness temperature; it can be obtained by using gain and
              offset value
            </p>
            <p>
              s<sub>i</sub> / atmospheric transmittance for channel i
            </p>

            <p>
              &epsilon;<sub>i</sub> / emissivity for channel i
            </p>
            <p>
              {" "}
              I<sup>Y</sup> / downwelling radiance
            </p>
            <p>
              I<sup>[</sup> / upwelling radiance
            </p>
            <p>
              Planck&rsquo;s equation can be further expressed as shown in{" "}
              <a href="#_bookmark15">Eq. (14.10)</a>.
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/vlh1410.png" alt="" /> ......(14.10)
            </p>
            <p>
              h / Planck&rsquo;s constant&nbsp;&nbsp;
              6.626&nbsp;&nbsp;&nbsp;&nbsp; 10<sup>&mdash;34</sup>
            </p>
            <p>
              J s c / speed of light&nbsp;&nbsp;&nbsp;&nbsp;
              2.98&nbsp;&nbsp;&nbsp;&nbsp; 10<sup>8</sup> m/s
            </p>
            <p>
              l<sub>i</sub> / effective wavelength for channel i
            </p>
            <p>
              k / Boltzmann constant&nbsp;&nbsp; 1.3806* 10<sup>&mdash;23</sup>{" "}
              J/K T<sub>s</sub>
            </p>
            <p> / Land Surface Temperature</p>

            <p>
              <a href="#_bookmark15">Eqs. (14.9) and (14.10</a>) were then
              rearranged to get <a href="#_bookmark16">Eq. (14.11)</a> which was
              utilized for estimating LST:
            </p>
            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/vlh1411.png" alt="" />
              .......(14.11){" "}
            </p>

            <p>Here,</p>
            <p>
              C<sub>1</sub> / 14,387.7 mm K.
            </p>
            <p>
              C<sub>2</sub> / 1.19104&nbsp;&nbsp;&nbsp;&nbsp; 10<sup>8</sup> W
              mm<sup>4</sup> m<sup>&mdash;2</sup> sr<sup>&mdash;1</sup>
            </p>
            <p>
              Atmospheric parameters including transmittance, upwelling, and
              downwelling radiance were
            </p>
            <p>
              estimated by using an online calculator as provided by NASA (
              <a href="https://atmcorr.gsfc.nasa.gov/">
                https://atmcorr.gsfc.nasa.gov/
              </a>
              ). The calculator considers geographic coordinates; information
              about the type of sensor; year, month, date, and time of image
              captured and surface meteorological parameters (temperature, the
              altitude of mounted sensor, pressure, and relative humidity).
              These parameters along with emissivity values were provided in{" "}
              <a href="#_bookmark16">Eq. (14.11)</a> to obtain LST. Further,
              interclass variability was assessed using the Coefficient of
              Variation (CoV) as shown in <a href="#_bookmark17">Eq. (14.12)</a>
              . CoV is a statistical parameter that defines how distributed the
              surface temperature is within the same land use class.
            </p>

            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/vlh1412.png" alt="" />
              .......(14.12){" "}
            </p>
            <p>
              Here, CoV = Coefficient of Variation (%), s = Standard deviation,
              m = mean.
            </p>
            <p>
              <ul>
                <li>
                  Estimation of Normalized Urban Heat Island Index (NUHII):
                  NUHII is an index that can define the intensity of heat
                  islands across the area of interest. This index was evaluated
                  by estimating LST for only urban area (extracted using land
                  use classification map and LST map obtained in previous
                  subsections) for 2019. LST for few areas with low-density
                  urban and very small urban pockets in the study area&rsquo;s
                  buffer region was averaged out to get the LST of rural NUHII
                  was then estimated using 13.
                </li>
              </ul>
            </p>

            <p style={{ textAlign: "center" }}>
              {" "}
              <img src="images/formula/vlh1413.png" alt="" />
              .......(14.13){" "}
            </p>

            <p>
              <ul>
                <li>
                  Derivation of relationship between LU and LST: This was
                  performed by overlaying land use maps and LST maps on each
                  other. A transact &ldquo;A-B&rdquo; was then considered over
                  LU map such that it covered all the classes. LST values
                  corresponding to this transact were considered to create a
                  temperature profile graph. This graph represented the LST
                  values for each LU class over the transact, and variations
                  were estimated.
                </li>
              </ul>
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default SAMPage;
